<template>
  <div>
    <el-table :data="tableData" border v-loading="loading" height="300px">
      <el-table-column prop="real_name" label="姓名" > </el-table-column>
      <!-- <el-table-column prop="phone" label="手机号码" width="120"> </el-table-column> -->
      <el-table-column prop="examine_text" label="审核状态" > </el-table-column>
    </el-table>
    <div class="u-f u-ac u-jsb ft_mr">
      <div></div>
      <div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[15, 30, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['doc_id'],
    data() {
      return {
        tableData: [],
        currentPage: 1,
                pagesize: 15,
                count: 0,
                loading:false,
      }
    },
    mounted() {
      this.begin()
    },
    methods: {
      begin() {
        let that = this
        that.currentPage = 1
        that.pagesize = 15
        that.search()
      },
      search() {
        let that = this
        that.loading = true
        axios.post("/admin/DoctorInvitationRecord/doctorInvitationRecord", {
            doc_id: this.doc_id,
             page: that.currentPage,
               page_count: that.pagesize,
          }, {
            token: true
          })
          .then(response => {
            that.loading = false
            that.tableData = response.data.data.list
             that.count = response.data.data.total_count
          })
          .catch(error => {})
      },
      handleSizeChange(val) {
        let that = this
        that.pagesize = val;
        that.search()
      },
      handleCurrentChange(val) {
        let that = this
        that.currentPage = val;
        that.search()
      },
    }
  }
</script>

<style>

</style>